import actionTypes from '../actions/privacy-policy.action-types';

export default (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PRIVACY_POLICY_REQUEST:
    case actionTypes.FETCH_PRIVACY_POLICY_SUCCESS:
    case actionTypes.FETCH_PRIVACY_POLICY_FAILURE:
      return action.hasError;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/components/reducers/privacy-policy-error.js